import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import { v4 as uuid } from "uuid";
import { DataGridListStyle, DRxInputStyle, HtmlTooltip } from "../../Theme";
import IconButton from "@mui/material/IconButton";
import PatientTooltip from "../PatientTooltip";
import { PatientSearchDetails } from "../../Apis/AuthApiServices";
import NoRecords from "../NoRecords";
import ErrorOverlay from "../ErrorOverlay";
import useDebounce from "../../CustomHooks/useDebounce";

export default function PatientNotMatchPopUp(props: any) {
  const {
    RequestData,
    setMatchingList,
    handleHidePatientNotMatchPopupClick,
    setRefillRequestData,
    setPatientInformation,
    setReviewData,
  } = props;
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState(false);
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const ptcolumnsPendingRefillAlertsRequest: GridColDef[] = [
    {
      field: "name",
      headerName: "Patient Name",
      width: 300,
      cellClassName: "w50",
      headerClassName: "w50",
      renderCell: ({ row }) => (
        <Typography
          component="div"
          variant="body2"
          color={"primary"}
          onClick={() => {
            if (setRefillRequestData) {
              setRefillRequestData({
                ...RequestData,
                patientFirstName: "",
                patientLastName: row?.name,
                personId: row?.personId,
                gender: row?.gender,
                age: row?.age,
                patientPhone: row?.homeTelephone,
                patientAddressLine1: row?.address,
                patientDateOfBirth: row?.dateOfBirth,
              });
              setMatchingList(true);
              handleHidePatientNotMatchPopupClick();
            } else if (setPatientInformation) {
              setPatientInformation({
                ...RequestData,
                patientName: row?.name,
                patientGender: row?.gender,
                patientAge: row?.age,
                patientAddress: row?.address,
                patientWorkPhone: row?.homeTelephone,
                patientId: row?.personId,
              });
              setMatchingList(true);
              handleHidePatientNotMatchPopupClick();
            } else if (setReviewData) {
              setReviewData({
                ...RequestData,
                name: row?.name,
                age: row?.age,
                dateOfBirth: row?.dateOfBirth,
                gender: row?.gender,
                address: row?.address,
                telePhone: row?.homeTelephone,
                patientId: row?.personId,
              });
              handleHidePatientNotMatchPopupClick();
            }
          }}
        >
          {row.name}
          <HtmlTooltip
            className="w316"
            placement="right"
            arrow
            title={<PatientTooltip row={row} />}
          >
            <IconButton className="tooltip">
              <img src={InfoIcon} alt="Tooltip" loading="lazy" />
            </IconButton>
          </HtmlTooltip>
        </Typography>
      ),
    },
    {
      field: "hostPatientId",
      headerName: " Patient ID	",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "homeTelephone",
      headerName: " Telephone	",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
    },
  ];
  const lastNameDebounce = useDebounce(lastName, 1000);
  const getPatientSearch = async () => {
    try {
      setLoading(true);
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("pageNumber", `${page}`);
      const bodyData = {
        lastName: lastNameDebounce,
      };
      const result = await PatientSearchDetails(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        setError(false);
      } else {
        setData([]);
        setLoading(false);
        setError(false);
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setError(true);
    }
  };
  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  useEffect(() => {
    if (lastNameDebounce) {
      getPatientSearch();
    }
  }, [page, lastNameDebounce]);
  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="top"
      justifyContent="center"
    >
      {" "}
      <Grid item xs={12} md={6}>
        <Typography
          component="div"
          variant="subtitle2"
          fontWeight={600}
          paddingBottom={1}
        >
          Patient Name for which below are the closest match
        </Typography>{" "}
        {/* <DRxInputStyle>
          <TextField
            id="lastName"
            name="lastName"
            type="text"
            value={""}
            placeholder={"Last Name"}
            style={{ width: "90%" }}
          />
        </DRxInputStyle> */}
        <DataGridListStyle>
          <DataGrid
            rows={RequestData?.matchingPatientsList ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={ptcolumnsPendingRefillAlertsRequest}
            getRowId={(row) => row.personId ?? uuid()}
            autoHeight
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            rowHeight={40}
            pageSize={3}
            rowsPerPageOptions={[3]}
            disableSelectionOnClick
          />
        </DataGridListStyle>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography
          component="div"
          variant="subtitle2"
          fontWeight={600}
          paddingBottom={1}
        >
          Search by Patient Name
        </Typography>{" "}
        <DRxInputStyle>
          <TextField
            id="lastName"
            name="lastName"
            type="text"
            value={lastName}
            onChange={(e: any) => {
              setLastName(e.target.value);
            }}
            placeholder={"Last Name"}
            style={{ width: "90%" }}
          />
        </DRxInputStyle>
        <DataGridListStyle>
          <DataGrid
            columns={ptcolumnsPendingRefillAlertsRequest}
            rows={data[0]?.items ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            autoHeight
            rowHeight={40}
            pageSize={pageSize}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            pagination
            paginationMode="server"
            loading={loading}
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            error={error || undefined}
            getRowId={(row) => row.personId ?? uuid()}
            rowCount={rowCountState}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            page={page}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          />
        </DataGridListStyle>
      </Grid>
    </Grid>
  );
}
